import React, { useState, useCallback, useEffect, useRef } from "react";
import styles from "./Settings.module.css";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { Org_shift_activation, updateOrgActivation, updateOrgApproval, updateSettings, updateFreezeApproval, updatePastDatepproval, updatePastDate, updateCallRecordingStatus } from "../../Services/organizations";
import Loading from "../../Components/Loading/Loading";
import Label from "../../Components/Label";
import ToggleButton from "../../Components/ToggleButton/ToggleButton";
import { v4 as uuidv4 } from 'uuid';
import { googleAnalytics } from "../../Services/users";
import { useHistory, useLocation } from "react-router-dom";
import {
  setCurrentRoute
} from "../../Redux/actions";



const Settings = ({ theme, user, organizationData, authToken,callRecordingModule }: any) => {
  const [load, setLoad] = useState(false);
  const [shiftStartTime, setShiftStartTime]: any = useState();
  const [shiftEndTime, setShiftEndTime]: any = useState();
  const [shiftReminder, setShiftReminder]: any = useState();
  const [shiftReminderAfter, setShiftReminderAfter]: any = useState();
  const [daysBeforeNotifying, setDaysBeforeNotifying]: any = useState();
  const [activate, setActivate] = useState(user.current_active_status);
  const [approve, setApprove] = useState(user.is_approval_enabled);
  const [activation, setActivation] = useState(user.is_shift_activation_enable);
  const dispatcher = useDispatch();
  const [freezeScreenApprove, setFreezeScreenApprove]: any = useState();
  const [isPastDateApprovalEnabled, setIsPastDateApprovalEnabled] = useState(false);
  const [isCallRecordingEnabled, setIsCallRecordingEnabled] = useState(false);
  const [gracePastDays, setGracePastDays]: any = useState();
  const [isGACalled, setIsGACalled] = useState<any>(false);
  useEffect(() => {
    let shiftStartTime = organizationData && organizationData.shift_start_time ? organizationData.shift_start_time : "10:00";
    let shiftEndTime = organizationData && organizationData.shift_end_time ? organizationData.shift_end_time : "18:30";
    let shiftReminder = organizationData && organizationData.shift_reminder ? organizationData.shift_reminder : 15;
    let shiftReminderAfter = organizationData && organizationData.shift_reminder_after ? organizationData.shift_reminder_after : 15;
    let daysBeforeNotifying = organizationData && organizationData.days_before_notifying ? organizationData.days_before_notifying : 3;
    let screenFreezeAfterCalling = organizationData && organizationData.is_freeze_enabled ? organizationData.is_freeze_enabled : false;
    let approvePastDate = organizationData && organizationData.is_past_date_approval_enabled ? organizationData.is_past_date_approval_enabled : false;
    let approvePastDays = organizationData && organizationData.grace_past_days ? organizationData.grace_past_days : 1;
    let approval = organizationData && organizationData.is_approval_enabled ? organizationData.is_approval_enabled : false;
    let callRecordingEnabled = callRecordingModule && callRecordingModule.is_call_recording_enabled ? callRecordingModule.is_call_recording_enabled : false;
    setShiftStartTime(shiftStartTime);
    setShiftEndTime(shiftEndTime);
    setShiftReminder(shiftReminder);
    setShiftReminderAfter(shiftReminderAfter);
    setDaysBeforeNotifying(daysBeforeNotifying);
    setFreezeScreenApprove(screenFreezeAfterCalling)
    setIsPastDateApprovalEnabled(approvePastDate)
    setGracePastDays(approvePastDays);
    setApprove(approval);
    setIsCallRecordingEnabled(callRecordingEnabled);
  }, [organizationData])

  useEffect(() => {
    setActivation(user.is_shift_activation_enable)
  }, [user.is_shift_activation_enable])

  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const tdStyles = {
    backgroundColor: theme
      ? themeColors.tdBackgroundColor
      : themeColors.tdBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const trBorderStyles = {
    borderBottomColor: theme
      ? `1px solid ${themeColors.trBorderColor}`
      : `1px solid ${themeColors.trBorderColorDark}`,
  };
  const thStyles = {
    backgroundColor: theme
      ? themeColors.thBackgroundColor
      : themeColors.thBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
    padding: "1rem",
  };
  const selectInputContainerStyles = { width: "140px", marginRight: "5px" };

  const submit = (e: any) => {
    e.preventDefault();
    setLoad(true);
    updateSettings(user.organization_id, shiftStartTime, shiftEndTime, shiftReminder, shiftReminderAfter, daysBeforeNotifying, setLoad, dispatcher);
  }
  const active = (status: any) => {
    setActivate(!activate)
    setLoad(true);
    updateOrgActivation(user.organization_id, status, setLoad, dispatcher);
  }
  const approval = (status: any) => {
    setApprove(!approve)
    setLoad(true);
    updateOrgApproval(user.organization_id, status, setLoad, dispatcher);
  }
  const shift_activation = (status: any) => {
    setActivation(!activation)
    setLoad(true);
    Org_shift_activation(user.organization_id, status, setLoad, dispatcher);
  }
  const freezeApproval = (status: any) => {
    setFreezeScreenApprove(!freezeScreenApprove)
    setLoad(true);
    updateFreezeApproval(user.organization_id, status, setLoad, dispatcher);
  }
  const pastDateApproval = (status: any) => {
    setIsPastDateApprovalEnabled(!isPastDateApprovalEnabled)
    setLoad(true);
    updatePastDatepproval(user.organization_id, status, setLoad, dispatcher);
  }
  const callRecordingUpdate = (status: any) => {
    setIsCallRecordingEnabled(!isCallRecordingEnabled)
    setLoad(true);
    updateCallRecordingStatus(user.organization_id, status, setLoad, dispatcher);
  }
  const submit1 = (e: any) => {
    e.preventDefault();
    setLoad(true);
    updatePastDate(user.organization_id, setLoad, dispatcher, gracePastDays);
  }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Settings_Screen',user)
      }
    }
  },[user])

     const [cRoute,setCRoute]=useState("") 
                 const location: any = useLocation();                    
                                    useEffect(() => {
                                      dispatcher(setCurrentRoute(location.pathname))
                                      setCRoute(location.pathname)
                                    }, [location]);
  return (
    <div
      className={styles.parent}
      style={containerStyles}
    >
      {load === true && <Loading />}
      <div
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        >
          {" "}
          {"Settings"}
        </h5>
      </div>
      <div
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
          <h6>Shift Reminder Timings</h6>
          <div className="mt-4">
            <div className="d-flex flex-row align-items-center">
              <Label label="Activate or Deactivate your organization according to shift-timing" required={false} />
              <input
                // style={{width:100,alignSelf:"center"}}
                type="checkbox"
                checked={activation}
                onChange={() => { shift_activation(!activation) }}
                className="mx-4 mb-1"
              />
            </div>
            <div className={styles.box2}>
              <div className={styles.divide}>
                <Label label="Shift Start Time" required={false} />
                <div className={styles.inputContainer}>
                  <input
                    defaultValue={shiftStartTime}
                    type="time"
                    placeholder="Enter time"
                    className={"form-control"}
                    onChange={(e) => { setShiftStartTime(e.target.value) }}
                    disabled={!activation}
                  />
                </div>
              </div>

              <div className={styles.divide}>
                <Label label="Shift End Time" required={false} />
                <div className={styles.inputContainer}>
                  <input
                    defaultValue={shiftEndTime}
                    type="time"
                    placeholder="Enter time"
                    className={"form-control"}
                    onChange={(e) => { setShiftEndTime(e.target.value) }}
                    disabled={!activation}
                  />
                </div>
              </div>
              <div className={styles.divide}>
                <Label label="Location Reminder (Before Shift)" required={false} />
                <div className={styles.inputContainer}>
                  <input
                    type="number"
                    placeholder="In minutes"
                    className="form-control"
                    defaultValue={shiftReminder}
                    style={{ fontSize: "14px" }}
                    onChange={(e) => { setShiftReminder(e.target.value) }}
                    disabled={!activation}
                  />
                </div>
              </div>
              <div className={styles.divide}>
                <Label label="Location Reminder (After Shift)" required={false} />
                <div className={styles.inputContainer}>
                  <input
                    type="number"
                    placeholder="In minutes"
                    className="form-control"
                    defaultValue={shiftReminderAfter}
                    style={{ fontSize: "14px" }}
                    onChange={(e) => { setShiftReminderAfter(e.target.value) }}
                    disabled={!activation}
                  />
                </div>
              </div>
            </div>
          </div>

          <h6 className="mt-4">Lead Notification</h6>
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Days Before Notifying" required={false} />
              <div className={styles.inputContainer}>
                <input
                  defaultValue={daysBeforeNotifying}
                  type="number"
                  placeholder="Enter Days"
                  className={"form-control"}
                  style={{ fontSize: "14px" }}
                  onChange={(e) => { setDaysBeforeNotifying(e.target.value) }}
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            // className="btn btn-primary mt-5"
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            onClick={(e: any) => {
              submit(e);
            }}
          >
            Submit
          </button>
        </form>
        <div className="card p-4 shadow rounded mt-2 d-flex flex-row gap-4 align-items-center" style={cardContainerStyles}>
          <div>{"Activate Or Deactivate Your Organization"}</div>
          {/* <button
                type="submit"
                style={{backgroundColor: activate===false?"#279f9f":"#EC7063"}}
                className={styles.button}
                onClick={()=> active(!activate)}>
                {user.current_active_status===true ?"Deactivate":"Activate"}
              </button> */}
          <div className="d-flex flex-row gap-2 align-items-center">
            <p className={styles.toggleLabel}>{activate ? "Deactivate" : "Activate"}</p>
            {/* <input type="checkbox"  onChange={()=>{alert("lk")}} /> */}
            <ToggleButton
              checked={activate}
              onChange={() => {
                active(!activate)
              }}
              id={uuidv4()}
              customStyles={{ backgroundColor: activate ? "#269f9f" : "#e8e8e8", border: activate ? "none" : "2px solid #d7d7d7" }}
            />
          </div>
          {/* <div style={{marginTop:"30px",color:"red"}}>{"* Activate or Deactivate your organization according to shift-timing"}</div>
              <input
                style={{marginTop:"-20px",width:100,alignSelf:"center"}}
                type="checkbox"
                checked={activation}
                onChange={() => {shift_activation(!activation)}}
              /> */}
        </div>
        {/* <div className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
          <div>{"Site-Visit and Meeting Approval "}</div>
          <button
            type="submit"
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            onClick={()=> approval(!approve)}>
            {user.is_approval_enabled===true ?"Disable":"Enable"}
          </button>
        </div> */}

        <div className="card p-4 shadow rounded mt-2 d-flex flex-row " style={cardContainerStyles}>

          <div className="d-flex flex-row flex-fill gap-4 align-items-center">
            <div>{"Site-Visit and Meeting Approval "}</div>
            {/* <button
              type="submit"
              style={{ backgroundColor: "#279f9f", marginTop: "-6px" }}
              className={styles.button}
              onClick={() => approval(!approve)}>
              {user.is_approval_enabled === true ? "Disable" : "Enable"}
            </button> */}
            <div className="d-flex flex-row gap-2 align-items-center">
              <p className={styles.toggleLabel}>{approve ? "Disable" : "Enable"}</p>
              <ToggleButton
                checked={approve}
                onChange={() => {
                  approval(!approve)
                }}
                id={uuidv4()}
                customStyles={{ backgroundColor: approve ? "#269f9f" : "#e8e8e8", border: approve ? "none" : "2px solid #d7d7d7" }}
              />
            </div>
          </div>

          <div className="d-flex flex-row flex-fill gap-4 align-items-center">
            <div>{"Freeze Lead Panel Approval "}</div>
            {/* <button
              type="submit"
              style={{ backgroundColor: "#279f9f", marginTop: "-6px" }}
              className={styles.button}
              onClick={() => freezeApproval(!freezeScreenApprove)}>
              {freezeScreenApprove ? "Disable" : "Enable"}
            </button> */}
            <div className="d-flex flex-row gap-2 align-items-center">
              <p className={styles.toggleLabel}>{freezeScreenApprove ? "Disable" : "Enable"}</p>
              <ToggleButton
                checked={freezeScreenApprove}
                onChange={() => {
                  freezeApproval(!freezeScreenApprove)
                }}
                id={uuidv4()}
                customStyles={{ backgroundColor: freezeScreenApprove ? "#269f9f" : "#e8e8e8", border: freezeScreenApprove ? "none" : "2px solid #d7d7d7" }}
              />
            </div>
          </div>

        </div>
        <div className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>
          <div className="d-flex flex-row">
            <div className="d-flex flex-row flex-fill gap-4 align-items-center">
              <div>Past Date Approval</div>
              {/* <button
                type="submit"
                style={{ backgroundColor: "#279f9f" , marginTop:"-6px"}}
                className={styles.button}
                onClick={()=> pastDateApproval(!isPastDateApprovalEnabled)}>
                {isPastDateApprovalEnabled ?"Disable":"Enable"}
              </button> */}
              <div className="d-flex flex-row gap-2 align-items-center">
                <p className={styles.toggleLabel}>{isPastDateApprovalEnabled ? "Disable" : "Enable"}</p>
                <ToggleButton
                  checked={isPastDateApprovalEnabled}
                  onChange={() => {
                    pastDateApproval(!isPastDateApprovalEnabled)
                  }}
                  id={uuidv4()}
                  customStyles={{ backgroundColor: isPastDateApprovalEnabled ? "#269f9f" : "#e8e8e8", border: isPastDateApprovalEnabled ? "none" : "2px solid #d7d7d7" }}
                />
              </div>
            </div>
            <div className="d-flex flex-row flex-fill gap-2 align-items-center">
              <Label label="Enter Past Days " required={false} />
              <div className={styles.inputContainer}>
                <input
                  type="number"
                  disabled={isPastDateApprovalEnabled === true ? false : true}
                  placeholder={"Enter days"}
                  className="form-control"
                  defaultValue={gracePastDays}
                  style={{ fontSize: "14px" }}
                  onChange={(e) => { setGracePastDays(e.target.value) }}
                  min="1"
                />

              </div>
            </div>
          </div>
          <button
            type="submit"
            style={{ backgroundColor: "#279f9f" }}
            className={styles.button}
            disabled={isPastDateApprovalEnabled === true ? false : true}
            onClick={(e: any) => {
              submit1(e);
            }}
          >
            Submit
          </button>
        </div>

        {
          (callRecordingModule.is_call_recording_subscribed && callRecordingModule.show_call_recording_enable_option) && (
            <div className="card p-4 border shadow rounded mt-2" style={cardContainerStyles}>
          <div className="d-flex flex-row">
            <div className="d-flex flex-row flex-fill gap-4 align-items-center">
              <div>Call Recordings</div>
              {/* <button
                type="submit"
                style={{ backgroundColor: "#279f9f" , marginTop:"-6px"}}
                className={styles.button}
                onClick={()=> pastDateApproval(!isPastDateApprovalEnabled)}>
                {isPastDateApprovalEnabled ?"Disable":"Enable"}
              </button> */}
              <div className="d-flex flex-row gap-2 align-items-center">
                <p className={styles.toggleLabel}>{isCallRecordingEnabled ? "Disable" : "Enable"}</p>
                <ToggleButton
                  checked={isCallRecordingEnabled}
                  onChange={() => {
                    callRecordingUpdate(!isCallRecordingEnabled)
                  }}
                  id={uuidv4()}
                  customStyles={{ backgroundColor: isCallRecordingEnabled ? "#269f9f" : "#e8e8e8", border: isCallRecordingEnabled ? "none" : "2px solid #d7d7d7" }}
                />
              </div>
            </div>
          </div>
        </div>
          )
        }
        </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    user: state.user.data,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken,
    callRecordingModule: state.callRecordingModule,
  };
};

export default connect(mapStateToProps)(Settings);
